import { Link } from "react-router-dom";
const NotFound = () => {
  return (
    <div className="not-found">
      <h2>
        Sorry,
        <p> Tha page cannot be found</p>
        <Link to="/">Back to the homepage...</Link>
      </h2>
    </div>
  );
};

export default NotFound;
